import React, { Component } from 'react';
import styled from 'styled-components';
import { breakpoints, colors } from '../../style-utilities/variables';
import {
  ReviewsStateContext,
  ReviewsStateConsumer
} from '../../context/ReviewsContext';
import ComponentStyles from '../../brand-styles/components/Reviews/ReviewsSection.styles';
import ReviewsList from '../../components/Reviews/ReviewsList';
import Heading from '../../components/Heading';
import ReviewsAddEdit from '../../components/Reviews/ReviewsAddEdit';
import ReviewsCount from '../../components/Reviews/ReviewsCount';
import FlyoutContentNotAuthed from '../../components/FlyoutContentNotAuthed';
import FlyoutBasic from '../../components/FlyoutBasic';
import UserService from '../../services/user.service';

import ArrowRight from '../../images/arrow-right.png';

export const ReviewSectionStyle = styled.div`
  margin: auto;
  text-align: center;
  width: 100%;
  padding-bottom: 30px;
  margin-top: 70px;
  margin: 0 auto;
  h2 {
    font-size: 36px;
    margin-bottom: 0.2em;
    font-family: Poppins;
    color: rgb(190, 13, 52);
    margin: .67em 0;
  }
  .review-bar {
    text-align: center;
    margin: 20px auto;
    padding: 20px;
    color: white;
    background: ${colors.primary};
    .write-review {
      display: block;
      margin-top: 8px;
      img {
        height: 11px;
        margin-left: 4px;
        filter: invert(100%);
        opacity: 1;
      }
    }
  }
  .review-content {
    display: grid;
    grid-template-columns: 30% 70%;
    padding: 40px;
    border-bottom: 1px solid black;
    .profile {
      text-align: left;
      img {
        width: 70px;
        border-radius: 50%;
      }
    }
    .review {
      text-align: left;
    }
  }
  .write-review {
    cursor: pointer;
  }

  @media (min-width: 400px) {
    .review-bar {
      padding: 30px;
      text-align: left;
      .write-review {
        display: inline-block;
        float: right;
        margin-top: -8px;
        margin-right: 33px;
      }
    }
  }
  ${ComponentStyles}
`;

class ReviewsSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAddReview: false,
      isAuthed: false
    };

    this.userService = new UserService();
  }

  componentDidMount() {
    const user = this.userService.getAuthenticatedUser();
    this.setState({
      isAuthed: user ? true : false
    });

    this.context.getExistingReview(this.props.type, this.props.slug);
  }

  componentDidUpdate(prevPros) {
    if (this.props.authenticatedUser !== prevPros.authenticatedUser) {
      this.setState({
        isAuthed: true
      });
    }
  }

  toggleShowAddReview = () => {
    this.setState(prevState => ({
      showAddReview: !prevState.showAddReview
    }));
  };

  render() {
    const { slug, type } = this.props;

    return (
      <ReviewsStateConsumer>
        {reviewsStateContext => {
          const { existingReview } = reviewsStateContext;

          const hasExistingReview = existingReview && existingReview.id;

          return (
            <ReviewSectionStyle id="review-section">
              <div className="small-img" />
              <h2>Reviews</h2>
              <div className="review-bar">
                <ReviewsCount type={type} slug={slug} />
                <span
                  className="write-review"
                  onClick={this.toggleShowAddReview}
                >
                  {hasExistingReview ? 'Edit Review' : 'Write a Review'}
                  <img className="arrow-right" src={ArrowRight} />
                </span>
              </div>
              <div className="review-flyout-block">
                <FlyoutBasic
                  className="flyout-basic"
                  styles={{
                    visible: this.state.showAddReview,
                    height: this.state.isAuthed ? '570px' : '250px',
                    width: '350px',
                    caretRight: '65px',
                    style: {
                      marginLeft: 'calc(80vw - 350px)',
                      marginTop: '12px',
                      position: 'relative',
                      top: '0px'
                    }
                  }}
                  onClose={this.toggleShowAddReview}
                >
                  {this.state.isAuthed ? (
                    <ReviewsAddEdit
                      type={type}
                      slug={slug}
                      onClose={this.toggleShowAddReview}
                    />
                  ) : (
                    <FlyoutContentNotAuthed title="Write Reviews & Rate Recipes" />
                  )}
                </FlyoutBasic>
              </div>
              <div>
                <ReviewsList type={type} slug={slug} />
              </div>
            </ReviewSectionStyle>
          );
        }}
      </ReviewsStateConsumer>
    );
  }
}

ReviewsSection.contextType = ReviewsStateContext;

export default ReviewsSection;
